export default __webpack_public_path__ + "static/media/logo-slack.3412e1d3.svg";